import React from 'react';

type Props = Readonly<{
  children: React.ReactNode;
  fallback: (error: Error) => React.ReactNode;
}>;

type State = Readonly<{
  error: Error | null;
}>;

export default class ErrorBoundary extends React.Component<Props, State> {
  state: State = {error: null};

  static getDerivedStateFromError(error: Error): State {
    return {error};
  }

  render() {
    if (this.state.error) {
      return this.props.fallback(this.state.error);
    }
    return this.props.children;
  }
}
